import { company_name } from "@/i18n/variables";

const not_available_card = {
	button: `Zu ${company_name} Ankündigungen gehen`,
	title: "NICHT VERFÜGBAR",
};

export default not_available_card;
